"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3375],{

/***/ 16647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ LoadImage_LoadImage; }
});

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61261);
// EXTERNAL MODULE: ../../.yarn/cache/react-npm-18.2.0-1eae08fee2-88e38092da.zip/node_modules/react/index.js
var react = __webpack_require__(91987);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(67748);
// EXTERNAL MODULE: ../../.yarn/__virtual__/react-loading-skeleton-virtual-652ec717e7/0/cache/react-loading-skeleton-npm-3.1.0-1d9cc9a93a-53d257c88e.zip/node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(58085);
// EXTERNAL MODULE: ../../.yarn/unplugged/styled-components-virtual-24edae5a63/node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(10278);
;// CONCATENATED MODULE: ./src/components/IfSkeleton/IfSkeleton.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




/**
 * isSkeleton 값에 따라 스켈레톤 UI를 보여준다.
 * @author 이현우
 * @param param0
 * @returns
 */ function IfSkeleton(_param) {
    var isSkeleton = _param.isSkeleton, children = _param.children, containerStyle = _param.containerStyle, containerW100P = _param.containerW100P, containerH100P = _param.containerH100P, containerWH100P = _param.containerWH100P, className = _param.className, style = _param.style, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 0 : _borderRadius, props = _objectWithoutProperties(_param, [
        "isSkeleton",
        "children",
        "containerStyle",
        "containerW100P",
        "containerH100P",
        "containerWH100P",
        "className",
        "style",
        "borderRadius"
    ]);
    var defaultContainerStyles = (0,react.useMemo)(function() {
        if (containerWH100P) {
            return {
                width: "100%",
                height: "100%"
            };
        } else if (containerW100P) {
            return {
                width: "100%"
            };
        } else if (containerH100P) {
            return {
                height: "100%"
            };
        }
        return {};
    }, [
        containerH100P,
        containerW100P,
        containerWH100P
    ]);
    if (!isSkeleton) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonBox, {
        style: _objectSpreadProps(_objectSpread({}, defaultContainerStyles, containerStyle), {
            borderRadius: borderRadius
        }),
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, _objectSpread({
            style: _objectSpreadProps(_objectSpread({
                display: "flex",
                alignItems: "center"
            }, style), {
                borderRadius: borderRadius
            })
        }, props))
    });
}
/* harmony default export */ var IfSkeleton_IfSkeleton = (IfSkeleton);
var SkeletonBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "IfSkeleton__SkeletonBox",
    componentId: "sc-4a536c0b-0"
})(_templateObject());

;// CONCATENATED MODULE: ./src/components/IfSkeleton/index.tsx
/* 작성자 : 이현우 */ 


// EXTERNAL MODULE: ../../.yarn/cache/react-merge-refs-npm-2.0.1-e038520c6a-c0b6fdb384.zip/node_modules/react-merge-refs/dist/index.mjs
var react_merge_refs_dist = __webpack_require__(56467);
;// CONCATENATED MODULE: ./src/components/LoadImage/LoadImage.tsx
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function LoadImage_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function LoadImage_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            LoadImage_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function LoadImage_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function LoadImage_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        LoadImage_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function LoadImage_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = LoadImage_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function LoadImage_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function LoadImage_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function LoadImage_templateObject() {
    var data = LoadImage_taggedTemplateLiteral([
        "\n          width: 100%;\n          height: 100%;\n          object-fit: ",
        ";\n          opacity: 1;\n        "
    ]);
    LoadImage_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = LoadImage_taggedTemplateLiteral([
        "\n          width: 0;\n          height: 0;\n          opacity: 0;\n        "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = LoadImage_taggedTemplateLiteral([
        "\n    translate: opacity 0.3s;\n    border-radius: ",
        ";\n    ",
        "\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = LoadImage_taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






/**
 * 이미지가 로드가 완료된 이후에 노출
 * @author 이현우
 */ var LoadImage = /*#__PURE__*/ react.forwardRef(function LoadImage(_param, ref) {
    var src = _param.src, w = _param.w, h = _param.h, q = _param.q, className = _param.className, imgFit = _param.imgFit, _skeletonSize = _param.skeletonSize, _borderRadius = _param.borderRadius, borderRadius = _borderRadius === void 0 ? 0 : _borderRadius, props = LoadImage_objectWithoutProperties(_param, [
        "src",
        "w",
        "h",
        "q",
        "className",
        "imgFit",
        "skeletonSize",
        "borderRadius"
    ]);
    var imageRef = (0,react.useRef)(null);
    var mergeRef = (0,react_merge_refs_dist/* mergeRefs */.l)([
        ref,
        imageRef
    ]);
    var _$ref = (0,react.useState)(false), imageLoaded = _$ref[0], setImageLoaded = _$ref[1];
    var _$ref1 = (0,react.useState)(false), hasError = _$ref1[0], setHasError = _$ref1[1];
    var handleChangeMeta = (0,react.useCallback)(function() {
        var _$ref, _$ref1, _$ref2, _$ref3, _$ref4;
        if ((imageRef === null || imageRef === void 0 ? void 0 : (_$ref = imageRef.current) === null || _$ref === void 0 ? void 0 : _$ref.naturalWidth) != null && (imageRef === null || imageRef === void 0 ? void 0 : (_$ref1 = imageRef.current) === null || _$ref1 === void 0 ? void 0 : _$ref1.naturalHeight) != null) props === null || props === void 0 ? void 0 : (_$ref4 = props.handleChangeMeta) === null || _$ref4 === void 0 ? void 0 : _$ref4.call(props, {
            width: imageRef === null || imageRef === void 0 ? void 0 : (_$ref2 = imageRef.current) === null || _$ref2 === void 0 ? void 0 : _$ref2.naturalWidth,
            height: imageRef === null || imageRef === void 0 ? void 0 : (_$ref3 = imageRef.current) === null || _$ref3 === void 0 ? void 0 : _$ref3.naturalHeight
        });
    }, [
        props
    ]);
    var updateLoadedState = (0,react.useCallback)(function() {
        if (src) {
            setImageLoaded(true);
            handleChangeMeta();
        }
    }, [
        handleChangeMeta,
        src
    ]);
    var handleImageLoaded = (0,react.useCallback)(function(e) {
        var _$ref;
        updateLoadedState();
        props === null || props === void 0 ? void 0 : (_$ref = props.onLoad) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
    }, [
        props,
        updateLoadedState
    ]);
    var handleImageError = (0,react.useCallback)(function(e) {
        var _$ref;
        setHasError(true);
        props === null || props === void 0 ? void 0 : (_$ref = props.onError) === null || _$ref === void 0 ? void 0 : _$ref.call(props, e);
    }, [
        props
    ]);
    var alreadyLoadedImageUpdateState = (0,react.useCallback)(_asyncToGenerator(runtime_default().mark(function _callee() {
        var _$ref, _$ref1;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!imageLoaded && (imageRef === null || imageRef === void 0 ? void 0 : (_$ref = imageRef.current) === null || _$ref === void 0 ? void 0 : _$ref.complete)) {
                        ;
                        updateLoadedState();
                        props === null || props === void 0 ? void 0 : (_$ref1 = props.onLoad) === null || _$ref1 === void 0 ? void 0 : _$ref1.call(props, {
                            status: "alreadyLoaded"
                        });
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        imageLoaded,
        props,
        updateLoadedState
    ]);
    var skeletonSize = (0,react.useMemo)(function() {
        return {
            width: (_skeletonSize === null || _skeletonSize === void 0 ? void 0 : _skeletonSize.width) || "100%",
            height: (_skeletonSize === null || _skeletonSize === void 0 ? void 0 : _skeletonSize.height) || "100%"
        };
    }, [
        _skeletonSize === null || _skeletonSize === void 0 ? void 0 : _skeletonSize.height,
        _skeletonSize === null || _skeletonSize === void 0 ? void 0 : _skeletonSize.width
    ]);
    (0,react.useEffect)(function() {
        alreadyLoadedImageUpdateState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IfSkeleton_IfSkeleton, {
                isSkeleton: !imageLoaded,
                duration: hasError ? 0 : undefined,
                style: LoadImage_objectSpread({}, skeletonSize),
                containerStyle: LoadImage_objectSpread({}, skeletonSize),
                borderRadius: borderRadius
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, LoadImage_objectSpreadProps(LoadImage_objectSpread({}, props), {
                src: (0,utils/* getResizeImage */.uU)({
                    url: src || "",
                    w: w,
                    h: h,
                    q: q
                }),
                onLoad: handleImageLoaded,
                onError: handleImageError,
                ref: mergeRef,
                imageLoaded: imageLoaded,
                className: className,
                imgFit: imgFit,
                borderRadius: borderRadius
            }))
        ]
    });
});
/* harmony default export */ var LoadImage_LoadImage = (LoadImage);
var StyledImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    displayName: "LoadImage__StyledImage",
    componentId: "sc-ee7bd367-0"
})(_templateObject3(), function(param) {
    var imageLoaded = param.imageLoaded, imgFit = param.imgFit, borderRadius = param.borderRadius;
    return (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), borderRadius, imageLoaded ? (0,styled_components_browser_esm/* css */.iv)(LoadImage_templateObject(), imgFit) : (0,styled_components_browser_esm/* css */.iv)(_templateObject1()));
});

;// CONCATENATED MODULE: ./src/components/LoadImage/index.tsx
/* 작성자 : 이현우 */ 



/***/ }),

/***/ 55806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ useDataLayer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);
/* harmony import */ var _hooks_useEffectOnce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87026);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35735);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



var useDataLayer = function(effect) {
    var remainEffect = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    var has = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var key = param.key, value = param.value;
        var ref, ref1;
        if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(value)) return window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.some(function(item) {
            return lodash__WEBPACK_IMPORTED_MODULE_2___default().has(item, key);
        });
        return window === null || window === void 0 ? void 0 : (ref1 = window.dataLayer) === null || ref1 === void 0 ? void 0 : ref1.some(function(item) {
            return (item === null || item === void 0 ? void 0 : item[key]) === value;
        });
    }, []);
    var handlePush = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var data = param.data, key = param.key;
        var ref;
        if (lodash__WEBPACK_IMPORTED_MODULE_2___default().isEmpty(data[key])) return;
        if (has({
            key: key,
            value: data[key]
        })) return;
        window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push(_objectSpread({}, data));
    }, [
        has
    ]);
    var handleRemove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var key = param.key, value = param.value;
        var ref;
        if (!has({
            key: key,
            value: value
        })) return;
        var index = window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.findIndex(function(item) {
            return (item === null || item === void 0 ? void 0 : item[key]) === value;
        });
        window.dataLayer.splice(index, 1);
    }, [
        has
    ]);
    var handlePushAndRemove = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(param) {
        var data = param.data, key = param.key;
        handlePush({
            data: data,
            key: key
        });
        handleRemove({
            key: key,
            value: data[key]
        });
    }, [
        handlePush,
        handleRemove
    ]);
    var isContainerLoad = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        var ref, ref1, ref2;
        return (ref = window) === null || ref === void 0 ? void 0 : (ref1 = ref.google_tag_manager) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataLayer) === null || ref2 === void 0 ? void 0 : ref2.gtmLoad;
    }, []);
    (0,_hooks_useEffectOnce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
        var remainEffectHandler = function() {
            if (remainEffect.current) {
                remainEffect.current = false;
                return effect === null || effect === void 0 ? void 0 : effect({
                    handlePush: handlePush,
                    handleRemove: handleRemove,
                    has: has,
                    handlePushAndRemove: handlePushAndRemove
                });
            }
        };
        window.addEventListener("load", remainEffectHandler);
        var destroyFunc;
        if (isContainerLoad()) {
            destroyFunc = remainEffectHandler();
        }
        return function() {
            destroyFunc === null || destroyFunc === void 0 ? void 0 : destroyFunc();
            window.removeEventListener("load", remainEffectHandler);
        };
    });
    return {
        handlePush: handlePush,
        handleRemove: handleRemove,
        has: has,
        handlePushAndRemove: handlePushAndRemove
    };
};


/***/ }),

/***/ 87026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91987);

/**
 * @author 이현우
 * effect 이벤트가 한번만 일어나게 처리하는 hook
 * @param effect
 */ var useEffectOnce = function(effect) {
    var destroyFunc = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var effectCalled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var renderAfterCalled = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // eslint-disable-next-line no-unused-vars
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), _ = ref[0], setVal = ref[1];
    if (effectCalled.current) {
        renderAfterCalled.current = true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!effectCalled.current) {
            destroyFunc.current = effect();
            effectCalled.current = true;
        }
        setVal(function(val) {
            return val + 1;
        });
        return function() {
            if (!renderAfterCalled.current) {
                return;
            }
            if (destroyFunc.current) {
                destroyFunc.current();
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
/* harmony default export */ __webpack_exports__["Z"] = (useEffectOnce);


/***/ })

}]);